var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";
import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { useLocation, useNavigate } from "react-router-dom";
import { getContentHubListing } from '../../services/listingsService';
import moment from 'moment';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
export default function StripContentHubListing(props) {
    var _this = this;
    var emptyCatObj = { children: [] };
    var preselectedTagsAnd = useRef(null);
    var preselectedCategIds = useRef(null);
    //const excludeCategIdsFromPreselectedFilters = useRef(null);
    //const filterableCategoriesListRef = useRef(null);
    //const filterableYearsListRef = useRef(null);
    //const filterableLocationsListRef = useRef(null);
    var lastSearchResultID = useRef(null);
    var splideRef = useRef(null);
    var facetsCountById = useRef(null);
    var facetsWithNoTagsAndSelectedCountById = useRef(null);
    var facetsWithNoTagsOrSelectedCountById = useRef(null);
    var facetsWithNoYearSelectedCountById = useRef(null);
    var processCards = function (cards) {
        cards && cards.forEach(function (card) {
            if (card.fields && card.fields.date) {
                var momentDate = moment(card.fields.date, "YYYY-MM-DD");
                card.fields.dateStr = momentDate.isValid() && momentDate.format('MMM D, YYYY');
            }
            else if (card.date) {
                var momentDate = moment(card.date, "YYYY-MM-DD");
                card.dateStr = momentDate.isValid() && momentDate.format('MMM D, YYYY');
            }
            if (card.categories) {
                card.categories = card.categories.map(function (cat) { return cat && cat.value || cat; });
            }
        });
        return cards;
    };
    var fields = props.fields, children = props.children, labels = props.labels, generalSettings = props.generalSettings;
    var featuredItem = fields && fields.featuredItem && processCards([fields.featuredItem])[0];
    var location = useLocation();
    var navigate = useNavigate();
    //const [areCategoriesBuilt, setAreCategoriesBuilt] = useState(false);
    var areCategoriesBuiltRef = useRef(false);
    var wasInitSearchMade = useRef(false);
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(false), canLoadMore = _b[0], setCanLoadMore = _b[1];
    var _c = useState(0), resultPosition = _c[0], setResultPosition = _c[1];
    var _d = useState([]), cards = _d[0], setCards = _d[1];
    var _e = useState([]), categories = _e[0], setCategories = _e[1];
    var _f = useState([]), locations = _f[0], setLocations = _f[1];
    var _g = useState([]), years = _g[0], setYears = _g[1];
    var categoriesRef = useRef(null);
    var locationsRef = useRef(null);
    var yearsRef = useRef(null);
    var _h = useState(null), selectedLocation = _h[0], setSelectedLocation = _h[1];
    var _j = useState(null), selectedYear = _j[0], setSelectedYear = _j[1];
    var _k = useState([]), selectedCategIds = _k[0], setSelectedCategIds = _k[1];
    var hiddenSiteIDInput = document.getElementById('hdnSiteID');
    var siteID = hiddenSiteIDInput && hiddenSiteIDInput.value;
    var sortByOptions = [{ title: "Date", value: "date" }, { title: "Title", value: "location" }];
    var _l = useState(sortByOptions[0].value), selectedSortBy = _l[0], setSelectedSortBy = _l[1];
    var _m = useState(false), sortAsc = _m[0], setSortAsc = _m[1];
    //const navigateToStory = (item: any) => {
    //    if (!item || !item.url) return;
    //    if (item.url[0] == "/") {
    //        navigate(item.url);
    //        return;
    //    }
    //};
    var updateCategoriesCount = function () {
        //console.log("update categories count");
        setLocations(function (prevLocations) {
            return prevLocations.map(function (categ) {
                categ.count = categ.valueId && (facetsWithNoTagsAndSelectedCountById.current || facetsCountById.current)[categ.valueId] || 0;
                return categ;
            });
        });
        setCategories(function (prevCategories) {
            return prevCategories.map(function (categ) {
                categ.count = categ.valueId && (facetsWithNoTagsOrSelectedCountById.current || facetsCountById.current)[categ.valueId] || 0;
                return categ;
            });
        });
        setYears(function (prevYears) {
            return prevYears.map(function (categ) {
                categ.count = categ.valueId && (facetsWithNoYearSelectedCountById.current || facetsCountById.current)["filter_" + categ.valueId] || 0;
                return categ;
            });
        });
    };
    var handleHashChanged = function () {
        var params = new URLSearchParams(window.location.hash.replace('#', ''));
        var categoryParam = params.get('category') || '';
        var locationParam = params.get('location') || '';
        var yearParam = parseInt(params.get('year')) || 0;
        var foundLocationCateg = (categoryParam || locationParam) && locationsRef.current && locationsRef.current.find(function (it) { return (categoryParam && it.value == categoryParam) || (locationParam && it.value == locationParam); });
        var foundCateg = (categoryParam || locationParam) && categoriesRef.current && categoriesRef.current.find(function (it) { return (categoryParam && it.value == categoryParam) || (locationParam && it.value == locationParam); });
        var foundYearCateg = (yearParam) && yearsRef.current && yearsRef.current.find(function (it) { return (yearParam && it.valueId == yearParam); });
        if (foundLocationCateg && foundLocationCateg.valueId) {
            setSelectedLocation(foundLocationCateg);
        }
        if (foundCateg && foundCateg.valueId) {
            setSelectedCategIds([foundCateg.valueId]);
        }
        if (foundYearCateg && foundYearCateg.valueId) {
            setSelectedYear(foundCateg);
        }
    };
    var buildCategories = function () {
        //var preselectedCategIds = (props.fields && props.fields.custom_uiTagIds || "").split(" ");;
        //var excludeCategIdsFromPreselectedFilters: string[] = [];
        // console.log("Build categories here: ", fields.custom_dataCategories, fields.custom_locationsFilters);
        var params = new URLSearchParams(window.location.hash.replace('#', ''));
        var categoryParam = params.get('category') || '';
        var locationParam = params.get('location') || '';
        //var yearParam = params.get('year') || '';
        var makeSearch = !wasInitSearchMade.current;
        try {
            //let newLocations = fields.custom_locationsFilters && JSON.parse(fields.custom_locationsFilters);
            if ((locationsRef.current || "").length) {
                //
                locationsRef.current.forEach(function (categ) {
                    categ.initCount = categ.valueId && facetsCountById.current[categ.valueId] || 0;
                });
                //locationsRef.current = newLocations;
                setLocations([{
                        text: (labels && labels["pc24.contentHub.AllLocations"] || "All"),
                        value: "all",
                        valueId: "",
                        initCount: 0
                    }].concat(locationsRef.current));
                var foundCateg = (categoryParam || locationParam) && locationsRef.current.find(function (it) { return (categoryParam && it.value == categoryParam) || (locationParam && it.value == locationParam); });
                if (preselectedCategIds.current.length) {
                    var foundPreselectCateg = locationsRef.current.find(function (it) { return (it.valueId && preselectedCategIds.current.indexOf(String(it.valueId)) >= 0); });
                    if (!foundCateg && foundPreselectCateg) {
                        foundCateg = foundPreselectCateg;
                    }
                    //foundPreselectCateg && excludeCategIdsFromPreselectedFilters.push(String(foundPreselectCateg.valueId));
                }
                if (foundCateg && foundCateg.valueId) {
                    setSelectedLocation(foundCateg);
                    makeSearch = false;
                }
            }
        }
        catch (e) {
            console.log("Build locations error:", e);
        }
        try {
            //let newCategories = fields.custom_dataCategories && JSON.parse(fields.custom_dataCategories);
            if ((categoriesRef.current || "").length) {
                categoriesRef.current.forEach(function (categ) {
                    categ.initCount = categ.valueId && facetsCountById.current[categ.valueId] || 0;
                });
                //categoriesRef.current = newCategories;
                setCategories([{
                        children: null,
                        icon: null,
                        text: (labels && labels["pc24.contentHub.AllCategs"] || "All"),
                        value: "all",
                        valueId: "",
                        initCount: 0
                    }].concat(categoriesRef.current));
                var foundCateg = (categoryParam || locationParam) && categoriesRef.current.find(function (it) { return (categoryParam && it.value == categoryParam) || (locationParam && it.value == locationParam); });
                if (preselectedCategIds.current.length) {
                    var foundPreselectCateg = categoriesRef.current.find(function (it) { return (it.valueId && preselectedCategIds.current.indexOf(String(it.valueId)) >= 0); });
                    if (!foundCateg && foundPreselectCateg) {
                        foundCateg = foundPreselectCateg;
                    }
                    // foundPreselectCateg && excludeCategIdsFromPreselectedFilters.push(String(foundPreselectCateg.valueId));
                }
                if (foundCateg && foundCateg.valueId) {
                    setSelectedCategIds([foundCateg.valueId]);
                    makeSearch = false;
                }
            }
        }
        catch (e) {
            console.log("Build categories error:", e);
        }
        var yearParam = parseInt(params.get('year')) || 0;
        var newYearsFilters = [];
        var specYearPref = "filter_";
        for (var key in facetsCountById.current) {
            if (String(key).indexOf("filter_") != 0)
                continue;
            var parsedVal = parseInt(key.substr(specYearPref.length)) || 0;
            newYearsFilters.push({
                text: String(parsedVal),
                value: String(parsedVal),
                valueId: parsedVal,
                initCount: facetsCountById.current[key]
            });
        }
        yearsRef.current = newYearsFilters;
        setYears([{
                text: (labels && labels["pc24.contentHub.AllYears"] || "All"),
                value: "all",
                valueId: 0,
                initCount: 0
            }].concat(newYearsFilters.sort(function (a, b) { return b.valueId - a.valueId; })));
        var foundCateg = (yearParam) && newYearsFilters.find(function (it) { return (yearParam && it.valueId == yearParam); });
        //if (!foundCateg && preselectedCategIds.length) {
        //    foundCateg = newYearsFilters.find((it: any) => (it.valueId && preselectedCategIds.indexOf(String(it.valueId)) >= 0));
        //    //foundCateg && excludeCategIdsFromPreselectedFilters.push(String(foundCateg.valueId));
        //}
        if (foundCateg && foundCateg.valueId) {
            setSelectedYear(foundCateg);
            makeSearch = false;
        }
        // preselectedTagsAnd.current = preselectedCategIds.filter((catId: string) => catId && excludeCategIdsFromPreselectedFilters.indexOf(catId) < 0).join(" ");
        areCategoriesBuiltRef.current = true;
        if (makeSearch) {
            search();
        }
        // setAreCategoriesBuilt(true);
    };
    var changeCategory = function (category, firstLevel) {
        if (!category)
            return;
        // all has no valueId value
        if (!category.valueId) {
            // all is selected
            setSelectedCategIds([]);
            return;
        }
        if (firstLevel) {
            if (selectedCategIds.indexOf(category.valueId) >= 0) {
                setSelectedCategIds([]);
            }
            else {
                setSelectedCategIds([category.valueId]);
            }
        }
        else {
            if (selectedCategIds.indexOf(category.valueId) >= 0) {
                setSelectedCategIds(selectedCategIds.filter(function (it) { return it != category.valueId; }));
            }
            else {
                setSelectedCategIds(__spreadArray(__spreadArray([], selectedCategIds, true), [category.valueId], false));
            }
        }
    };
    function generateUniqueId() {
        return 'id-' + Math.random().toString(36).substr(2, 9);
    }
    var loadStaticCards = function () {
        if (!(fields.selectedCards || "").length) {
            return;
        }
        var newCards = fields.selectedCards.map(function (oldCard, index) {
            return {
                "categories": oldCard.categories,
                "id": oldCard.id,
                "position": index,
                "url": oldCard.fields.externalUrl || oldCard.url,
                "isExternal": !!oldCard.fields.externalUrl,
                "publicationName": oldCard.fields.publicationName,
                "publicationLogo": oldCard.fields.publicationLogo,
                "title": oldCard.fields.displayTitle || oldCard.fields.title,
                "tags": "",
                "date": oldCard.fields.date,
                "readTime": oldCard.fields.readTime,
                "content": oldCard.fields.content,
                "type": oldCard.fields.typeIcon,
                "animatedGIF": oldCard.fields.animatedGIF,
                "animatedGIF_Title": oldCard.fields.animatedGIF_title,
                "animatedGIF_Description": oldCard.fields.animatedGIF_description,
                "fullHeightImage": oldCard.fields.card_FullH_Thumb,
                "fullHeightImage_Title": oldCard.fields.card_FullH_Thumb_title,
                "fullHeightImage_Description": oldCard.fields.card_FullH_Thumb_description,
                "fullWidthImage": oldCard.fields.card_FullW_Thumb,
                "fullWidthImage_Title": oldCard.fields.card_FullH_Thumb_title,
                "fullWidthImage_Description": oldCard.fields.card_FullH_Thumb_description,
            };
        });
        setIsLoading(false);
        setCards(processCards(newCards));
    };
    var updateUrlHash = function (selectedCategs, selectedLocation, selectedYear) {
        if (!fields.fullOptions || !areCategoriesBuiltRef.current)
            return;
        var params = new URLSearchParams();
        var parmCount = 0;
        selectedCategs && (++parmCount) && params.set('category', selectedCategs);
        selectedLocation && (++parmCount) && params.set('location', selectedLocation);
        selectedYear > 0 && (++parmCount) && params.set('year', String(selectedYear));
        // window.location.hash = parmCount > 0 ? params.toString() : "#all";
        //history.scrollRestoration = 'manual';
        navigate(parmCount > 0 ? "#" + params.toString() : "#all", { replace: true, preventScrollReset: true, state: { hashChange: true } });
    };
    var search = function (loadMore, loadCategsOnly, callback) {
        if (loadMore === void 0) { loadMore = false; }
        if (loadCategsOnly === void 0) { loadCategsOnly = false; }
        if (callback === void 0) { callback = null; }
        return __awaiter(_this, void 0, void 0, function () {
            var result, selectedFirstCategValue, hasSecondCategs, searchCategValues, currentSearchResultID, e_1, newResults;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!loadCategsOnly) {
                            wasInitSearchMade.current = true;
                        }
                        if ((fields.selectedCards || "").length) {
                            loadStaticCards();
                            return [2 /*return*/];
                        }
                        if (isLoading && loadMore)
                            return [2 /*return*/];
                        lastSearchResultID.current = generateUniqueId();
                        !loadMore && setCards([]);
                        setIsLoading(true);
                        result = null;
                        selectedFirstCategValue = null;
                        hasSecondCategs = false;
                        searchCategValues = [];
                        selectedCategIds && selectedCategIds.forEach(function (categId) {
                            var foundCateg = null;
                            var isFirstCateg = false;
                            categories.forEach(function (categ) {
                                if (!!foundCateg)
                                    return;
                                if (categ.valueId == categId) {
                                    foundCateg = categ;
                                    isFirstCateg = true;
                                    selectedFirstCategValue = categ.value;
                                }
                                else {
                                    categ.children && categ.children.forEach(function (categSecond) {
                                        if (!!foundCateg)
                                            return;
                                        if (categSecond.valueId == categId) {
                                            foundCateg = categSecond;
                                            searchCategValues.push(foundCateg.value);
                                            hasSecondCategs = true;
                                        }
                                        //
                                    });
                                }
                            });
                        });
                        if (!hasSecondCategs && selectedFirstCategValue) {
                            searchCategValues.push(selectedFirstCategValue);
                        }
                        !loadMore && updateUrlHash(searchCategValues && searchCategValues.join("|"), selectedLocation && selectedLocation.valueId && selectedLocation.value, selectedYear && selectedYear.valueId);
                        currentSearchResultID = lastSearchResultID.current;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getContentHubListing(loadMore ? resultPosition : 0, {
                                categoriesRootRequired: generalSettings && generalSettings.fields.storiesCategoriesRoot || "",
                                returnFacetsOnly: !!loadCategsOnly,
                                excludeids: fields.excludeids || (featuredItem && fields.showFeaturedItem && fields.custom_canShowFeatured ? String(featuredItem.nodeId) : ""),
                                uiFilter: fields.uIFilter,
                                locationsFilter: fields.locationsFilter,
                                sortBy: selectedSortBy,
                                sortAsc: sortAsc,
                                storiesDisplayCategoriesRootPath: fields.custom_storiesDisplayCategoriesRootPath,
                                siteID: siteID,
                                cultureCode: "en-CA",
                                resultsPerPage: fields.pageSize > 0 ? fields.pageSize : 6,
                                preselectedGeoTags: fields.custom_geoTagIds || "",
                                preselectedTagsAnd: preselectedTagsAnd.current || "",
                                tagsOr: searchCategValues && searchCategValues.join(" "),
                                tagsAnd: selectedLocation && selectedLocation.valueId && selectedLocation.value || null,
                                year: selectedYear && selectedYear.valueId
                            })];
                    case 2:
                        result = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        //if (!(years || "").length) {
                        //    buildYearFilter(result && result.facets);
                        //}
                        if (currentSearchResultID != lastSearchResultID.current) {
                            console.log("Not latest call made - ignore", currentSearchResultID, lastSearchResultID.current);
                            return [2 /*return*/];
                        }
                        facetsCountById.current = Object.create(null);
                        facetsCountById.current["0"] = result && result.totalCount;
                        (result && result.facets && result.facets).forEach(function (facet) {
                            facetsCountById.current[facet.value] = facet.count;
                        });
                        if (result && result.facetsWithNoTagsAndSelected && result.facetsWithNoTagsAndSelected.length) {
                            facetsWithNoTagsAndSelectedCountById.current = Object.create(null);
                            //facetsWithNoTagsAndSelectedCountById.current["0"] = result && result.totalCount;
                            result.facetsWithNoTagsAndSelected.forEach(function (facet) {
                                facetsWithNoTagsAndSelectedCountById.current[facet.value] = facet.count;
                            });
                        }
                        else {
                            facetsWithNoTagsAndSelectedCountById.current = null;
                        }
                        if (result && result.facetsWithNoTagsOrSelected && result.facetsWithNoTagsOrSelected.length) {
                            facetsWithNoTagsOrSelectedCountById.current = Object.create(null);
                            //facetsWithNoTagsAndSelectedCountById.current["0"] = result && result.totalCount;
                            result.facetsWithNoTagsOrSelected.forEach(function (facet) {
                                facetsWithNoTagsOrSelectedCountById.current[facet.value] = facet.count;
                            });
                        }
                        else {
                            facetsWithNoTagsOrSelectedCountById.current = null;
                        }
                        if (result && result.facetsWithNoYearSelected && result.facetsWithNoYearSelected.length) {
                            facetsWithNoYearSelectedCountById.current = Object.create(null);
                            //facetsWithNoTagsAndSelectedCountById.current["0"] = result && result.totalCount;
                            result.facetsWithNoYearSelected.forEach(function (facet) {
                                facetsWithNoYearSelectedCountById.current[facet.value] = facet.count;
                            });
                        }
                        else {
                            facetsWithNoYearSelectedCountById.current = null;
                        }
                        if (loadCategsOnly) {
                            callback && callback();
                            return [2 /*return*/];
                        }
                        setIsLoading(false);
                        updateCategoriesCount();
                        setCanLoadMore(result && result.morePages || false);
                        newResults = processCards(result && result.cards) || [];
                        if (loadMore) {
                            newResults = (cards || []).concat(newResults);
                            setCards(newResults);
                        }
                        else {
                            setCards(newResults);
                        }
                        setResultPosition((newResults || "").length);
                        return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        // console.log("init StripContentHubListing:", props);
        preselectedCategIds.current = (props.fields && props.fields.custom_uiTagIds || "").split(" ");
        var excludeCategIdsFromPreselectedFilters = [];
        try {
            var newCategories = fields.custom_dataCategories && JSON.parse(fields.custom_dataCategories);
            categoriesRef.current = newCategories;
            if (preselectedCategIds.current.length) {
                var foundPreselectCateg = newCategories && newCategories.find(function (it) { return (it.valueId && preselectedCategIds.current.indexOf(String(it.valueId)) >= 0); });
                foundPreselectCateg && excludeCategIdsFromPreselectedFilters.push(String(foundPreselectCateg.valueId));
            }
            var newLocations = fields.custom_locationsFilters && JSON.parse(fields.custom_locationsFilters);
            locationsRef.current = newLocations;
            if (preselectedCategIds.current.length) {
                var foundPreselectCateg = newLocations && newLocations.find(function (it) { return (it.valueId && preselectedCategIds.current.indexOf(String(it.valueId)) >= 0); });
                foundPreselectCateg && excludeCategIdsFromPreselectedFilters.push(String(foundPreselectCateg.valueId));
            }
            //preselectedTagsAnd.current = newCategories && preselectedCategIds.current.filter((catId: any) => catId && !newCategories.find((cat: any) => cat.valueId && cat.valueId == catId)).join(" ");
            preselectedTagsAnd.current = preselectedCategIds.current.filter(function (catId) { return catId && excludeCategIdsFromPreselectedFilters.indexOf(catId) < 0; }).join(" ");
        }
        catch (e) {
            console.log("experiences: ", e);
        }
        if (fields.fullOptions) {
            search(false, true, function () {
                buildCategories();
            });
        }
        else {
            search();
            // TODO: ?
        }
        // search();
        var onHashChange = function () {
            //console.log("Hash changed to:", window.location.hash);
            handleHashChanged();
        };
        // Add the event listener
        window.addEventListener("hashchange", onHashChange);
        // Cleanup the event listener on unmount
        return function () {
            window.removeEventListener("hashchange", onHashChange);
        };
    }, []);
    //useEffect(() => {
    //    console.log("Hash changed to:", location.hash);
    //}, [location.hash]);
    useEffect(function () {
        // console.log("content hub selected category changed");
        if (areCategoriesBuiltRef.current) {
            search();
        }
    }, [selectedCategIds, selectedLocation, selectedYear, sortAsc, selectedSortBy]);
    var seeAllStoriesUrl = generalSettings && generalSettings.fields.storiesRootPath && generalSettings.fields.storiesRootPath.url || "";
    var cardsHtmlEls = !!(cards || '').length &&
        cards.map(function (item) {
            return React.createElement("a", { href: item.url, target: item.isExternal ? "_blank" : "", className: "hub-item-card", onClick: props.handleStripLinkClick || null },
                React.createElement("div", { className: "story-details" },
                    (item.fullHeightImage || item.fullWidthImage) &&
                        React.createElement("div", { className: "story-image" },
                            React.createElement("div", { className: "img-container" },
                                React.createElement("img", { src: item.fullHeightImage || item.fullWidthImage, title: item.fullHeightImage_Title || item.fullWidthImage_Title || item.title, alt: item.fullHeightImage_Description || item.fullWidthImage_Description || item.title, className: "img-fluid card-img", itemProp: "image" }))) || null,
                    (item.dateStr) &&
                        React.createElement("div", { className: "date-time-to-read mb-2" },
                            React.createElement("span", { className: "article-date me-4" }, item.dateStr)) || null,
                    item.title &&
                        React.createElement("div", { className: "story-title mb-3" },
                            React.createElement("div", { className: "h6", title: item.title, itemProp: "headline" }, item.title)) || null,
                    item.content &&
                        React.createElement("div", { className: "story-content pe-2", dangerouslySetInnerHTML: { __html: item.content } })
                        || null));
        }) || null;
    var splideConfig = {
        rewind: true,
        autoWidth: false,
        gap: 20,
        arrows: false,
        pagination: false,
        perPage: 3,
        breakpoints: {
            1400: {
                perPage: 3,
            },
            1100: {
                perPage: 3,
            },
            790: {
                perPage: 2,
            },
            576: {
                perPage: 1,
                gap: 24,
                fixedWidth: '260px',
            }
        }
    };
    var selectedSortByOption = sortByOptions.find(function (op) { return op.value == selectedSortBy; });
    return (React.createElement(motion.div, __assign({ initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip spa-content-hub-listing position-relative "
            + fields.backgroundColor
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
            + (fields.textColor ? (" text-color-" + fields.textColor) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "container" },
            fields.displayTitle &&
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col" },
                        React.createElement("div", { className: "d-flex align-items-center justify-content-between mb-4" },
                            React.createElement("h2", { className: "strip-title " + (fields.titleStyle ? fields.titleStyle : ""), dangerouslySetInnerHTML: { __html: fields.displayTitle } }),
                            !fields.fullOptions && seeAllStoriesUrl && React.createElement("div", { className: "see-all d-none d-sm-block" },
                                React.createElement("a", { href: seeAllStoriesUrl, title: "See All...", className: "btn btn-primary" }, (labels && labels["pc24.contentHub.SeeMoreStories"] || "See More Stories"))) || null))),
            React.createElement("div", { className: "stories-container mt-3" },
                featuredItem && fields.showFeaturedItem && fields.custom_canShowFeatured && React.createElement("div", { className: "row featured-story-row" },
                    React.createElement("div", { className: "mb-3 col-lg-8" }, (featuredItem.fields.card_FullW_Thumb || featuredItem.fields.card_FullH_Thumb) &&
                        React.createElement("a", { className: "story-card", href: featuredItem.fields.externalUrl || featuredItem.url, target: featuredItem.fields.externalUrl && "_blank" || "", onClick: props.handleStripLinkClick || null },
                            React.createElement("div", { className: "story-image" },
                                React.createElement("img", { src: featuredItem.fields.heroThumbnail || featuredItem.fields.card_FullW_Thumb || featuredItem.fields.card_FullH_Thumb, title: featuredItem.fields.heroThumbnail_title || featuredItem.fullWidthImage_title || featuredItem.fullHeightImage_title || featuredItem.fields.title, alt: featuredItem.fields.heroThumbnail_description || featuredItem.fullWidthImage_description || featuredItem.fullHeightImage_description || featuredItem.fields.title, className: "img-fluid card-img", itemProp: "image" }),
                                React.createElement("div", { className: "category" }, (labels && labels["pc24.contentHub.Featured"] || "Featured"))))),
                    React.createElement("div", { className: "col-lg-4" },
                        React.createElement("div", { className: "story-details" },
                            (featuredItem.fields.dateStr) &&
                                React.createElement("div", { className: "date-time-to-read" },
                                    React.createElement("span", { className: "article-date me-4" }, featuredItem.fields.dateStr)),
                            (featuredItem.fields.displayTitle || featuredItem.fields.title) &&
                                React.createElement("div", { className: "story-title" },
                                    React.createElement("div", { className: "h3 mb-0", title: featuredItem.fields.title, itemProp: "headline" }, (featuredItem.fields.displayTitle || featuredItem.fields.title))),
                            featuredItem.fields.content &&
                                React.createElement("div", { className: "story-content", dangerouslySetInnerHTML: { __html: featuredItem.fields.content } }),
                            React.createElement("div", { className: "featured-story-learn-more" },
                                React.createElement("a", { className: "btn btn-primary", href: featuredItem.fields.externalUrl || featuredItem.url, target: featuredItem.fields.externalUrl && "_blank" || "" }, (labels && labels["pc24.contentHub.LearnMore"] || "Learn More")))))) || null,
                fields.fullOptions && fields.showUIFilters && !(fields.selectedCards || "").length && React.createElement("div", { className: "row content-hub-filters" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement("div", { className: "stories-categories" }, categories && categories.map(function (category, c) {
                            // all has no valueId
                            var isActive = (!category.valueId && !selectedCategIds.length || selectedCategIds.indexOf(category.valueId) >= 0);
                            if (category.valueId > 0 && category.initCount == 0)
                                return null;
                            //var count = facetsCountById.current && facetsCountById.current[category.valueId ? String(category.valueId) : "0"] || 0;
                            return React.createElement(Button, { disabled: category.valueId > 0 && category.count === 0, color: isActive ? "outline" : "primary", className: (isActive ? "active" : ""), key: category.value, onClick: function () { return changeCategory(category, true); } }, category.text) || null; //<sup>{count}</sup>
                        }) || null),
                        React.createElement("div", { className: "stories-subcategories" }, ((categories && categories.find(function (category) { return selectedCategIds.indexOf(category.valueId) >= 0; }) || emptyCatObj).children || []).map(function (category, c) {
                            // all has no valueId
                            var isActive = (!category.valueId && !selectedCategIds.length || selectedCategIds.indexOf(category.valueId) >= 0);
                            //var count = facetsCountById.current && facetsCountById.current[category.valueId ? String(category.valueId) : "0"] || 0;
                            if (!isActive && category.valueId > 0 && category.initCount == 0)
                                return null;
                            return React.createElement(Button, { disabled: category.valueId > 0 && category.count === 0, color: isActive ? "outline" : "link", className: "btn " + (isActive ? "active" : ""), key: category.value, onClick: function () { return changeCategory(category, false); } }, category.text) || null; //<sup>{count}</sup>
                        }))),
                    (locations || "").length > 0 && React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col" },
                            React.createElement("div", { className: "sorting-options" },
                                React.createElement("div", { className: "label" }, (labels && labels["pc24.contentHub.FilterBy"] || "Filter By:")),
                                React.createElement("div", { className: "filter-options" },
                                    React.createElement("div", { className: "form-group border-radius  country form-floating" },
                                        React.createElement(UncontrolledButtonDropdown, { className: "w-100 btn-group" },
                                            React.createElement(DropdownToggle, { cssModule: { 'btn-secondary': 'form-control' }, className: "dropdown-toggle btn form-control" },
                                                (selectedLocation && selectedLocation.valueId && selectedLocation.text || (labels && labels["pc24.contentHub.SelectLocation"] || "Select Location")),
                                                React.createElement("i", { className: "fa-solid fa-angle-down ms-4 fs-xs" })),
                                            React.createElement(DropdownMenu, { className: "" }, locations.map(function (option, index) {
                                                if ((selectedLocation && selectedLocation.valueId != option.valueId || !selectedLocation) && option.valueId > 0 && option.initCount == 0)
                                                    return null;
                                                return React.createElement(DropdownItem, { key: "ddd" + option.value + index, disabled: option.valueId > 0 && option.count === 0, className: "text-concrete fs-xs", "data-val": option, onClick: function () { return setSelectedLocation(option); } }, option.text);
                                            })))),
                                    (years || "").length > 0 &&
                                        React.createElement("div", { className: "form-group border-radius country form-floating" },
                                            React.createElement(UncontrolledButtonDropdown, { className: "w-100 btn-group" },
                                                React.createElement(DropdownToggle, { cssModule: { 'btn-secondary': 'form-control' }, className: "dropdown-toggle btn form-control" },
                                                    (selectedYear && selectedYear.valueId && selectedYear.text || (labels && labels["pc24.contentHub.SelectYear"] || "Select Year")),
                                                    React.createElement("i", { className: "fa-solid fa-angle-down ms-4 fs-xs" })),
                                                React.createElement(DropdownMenu, { className: "" }, years.map(function (option, index) {
                                                    if ((selectedYear && selectedYear.valueId != option.valueId || !selectedYear) && option.valueId > 0 && option.initCount == 0)
                                                        return null;
                                                    return React.createElement(DropdownItem, { key: "ddd" + option.value + index, disabled: option.valueId > 0 && option.count === 0, className: "text-concrete fs-xs", "data-val": option, onClick: function () { return setSelectedYear(option); } }, option.text);
                                                })))) || null)))) || null) || null,
                !!fields.fullOptions && cardsHtmlEls && React.createElement("div", { className: "row" }, cardsHtmlEls.map(function (newcard) { return React.createElement("div", { className: "mb-5 col-md-4" }, newcard); })) || null,
                !fields.fullOptions && cardsHtmlEls && React.createElement("div", { className: "row" },
                    " ",
                    React.createElement(Splide, { ref: splideRef, hasTrack: false, options: splideConfig },
                        React.createElement(SplideTrack, null, cardsHtmlEls === null || cardsHtmlEls === void 0 ? void 0 : cardsHtmlEls.map(function (cardChild, index) { return (React.createElement(SplideSlide, { key: index }, cardChild)); }))),
                    " ") || null,
                !isLoading && !(cards || '').length && React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12 no-result-found mb-4 display-3 text-center", dangerouslySetInnerHTML: { __html: (labels && labels["pc24.contentHub.NoResults"] || "No results") } })) || null,
                isLoading && React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12 no-result-found mb-4 display-3 text-center" },
                        React.createElement("img", { src: "/images/pursuit/loading.gif", title: "Loading...", alt: "Loading..." }))) || null,
                fields.fullOptions && !isLoading && canLoadMore && React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12 my-4 text-center" },
                        React.createElement("button", { className: "btn btn-primary load-more", onClick: function () { return search(true); } }, (labels && labels["pc24.contentHub.LoadMore"] || "Load More Articles")))) || null),
            React.createElement("div", { className: "d-block d-sm-none mt-4 pt-3" }, !fields.fullOptions && seeAllStoriesUrl && React.createElement("div", { className: "see-all" },
                React.createElement("a", { href: seeAllStoriesUrl, title: "See All...", className: "btn btn-primary" }, (labels && labels["pc24.contentHub.SeeMoreStories"] || "See More Stories"))) || null))));
}
